<div class="container">
  <h1 class="c11n-text-2xl-headline margin-bottom-2" data-cy="pageTitle" [innerHTML]="content.pageTitle"></h1>
  <vgim-investment-options
    (continueAsDA)="onContinueAsDA()"
    (continueAsIs)="onContinueWithoutDA($event)"
  >
  </vgim-investment-options>
  <app-feedback-survey></app-feedback-survey>
  <div class="c11n-text-sm disclaimers-wrapper" data-cy="disclaimer">
    <span [innerHTML]="openChoiceCommonContent.disclaimer.part1"></span>
    <span [innerHTML]="openChoiceCommonContent.disclaimer.part2"></span>
    <a c11n-link [variant]="'secondary-reinforced'" [fontWeight]="'normal'" [href]="openChoiceCommonContent.disclaimer.linkHref">{{ openChoiceCommonContent.disclaimer.linkText }}</a>
    <span [innerHTML]="openChoiceCommonContent.disclaimer.part3"></span>
    <span [innerHTML]="content.footer"></span>
  </div>
  <vgim-secure-link></vgim-secure-link>
</div>